import { HG_CARTE_FOND } from '@/data/hg-carte-fond';

/* Conversion pixel ↔ coordonnées géographiques pour le fond de carte HG
   collège. Extrait de hg-college-carte-vue.tsx (galerie #1351) pour être
   partagé, testé une seule fois, et réutilisé tel quel par l'écran de
   production — c'est la pièce dont un écran qui évalue un vrai élève ne peut
   pas se permettre une seconde version qui diverge de la première. */

const rad = (deg: number) => (deg * Math.PI) / 180;

export function pointDepuisPixels(x: number, y: number): { lon: number; lat: number } {
  const { largeur, lon0, lon1, lat0, lat1 } = HG_CARTE_FOND;
  const latMoyenne = rad((lat0 + lat1) / 2);
  const etendueX = (lon1 - lon0) * Math.cos(latMoyenne);
  const echelle = largeur / etendueX;
  return {
    lon: lon0 + x / echelle / Math.cos(latMoyenne),
    lat: lat1 - y / echelle,
  };
}

export function pixelsDepuisPoint(lon: number, lat: number): { x: number; y: number } {
  const { largeur, lon0, lon1, lat0, lat1 } = HG_CARTE_FOND;
  const latMoyenne = rad((lat0 + lat1) / 2);
  const echelle = largeur / ((lon1 - lon0) * Math.cos(latMoyenne));
  return { x: (lon - lon0) * Math.cos(latMoyenne) * echelle, y: (lat1 - lat) * echelle };
}
